import axios from "axios";

const cityAxios = axios.create({
    baseURL: process.env.REACT_APP_CITY_BASE_URL
})
const ipAxios = axios.create({
    baseURL: process.env.REACT_APP_IP_BASE_URL
})
const sunriseAxios = axios.create({
    baseURL: process.env.REACT_APP_SUNRISE_BASE_URL
})
const vatAxios = axios.create({
    baseURL: process.env.REACT_APP_VAT_BASE_URL
})

export { cityAxios , ipAxios , sunriseAxios , vatAxios }